const key = "announcement-bar-top";

export const announcementBarTop = {
    key: key,
    init: (active) => {

        let styleEl = document.getElementById(`${key}-style`);
        if(!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = `${key}-style`
            // Append <style> element to <head>
            document.head.appendChild(styleEl);
        }
        
        const styleSheet = styleEl.sheet;
        const headerSecondaryNav = document.querySelector(".header__wrapper");
        if(active){
            headerSecondaryNav.classList.add("header__wrapper--announcement");
            styleSheet.insertRule(".shopify-section--header + .shopify-section--announcement-bar{display:none !important;}", 0);
        }else{
            headerSecondaryNav.classList.remove("header__wrapper--announcement");
            while (styleSheet.cssRules.length > 0) {
                styleSheet.deleteRule(0);
            }
        }
    }
}